export default "__VITE_ASSET__D4qHT8Fx__"